import { configureStore } from '@reduxjs/toolkit';
import { backendApi } from 'src/backend';
import userProfileReducer from 'src/components/UserStore/userProfileSlice';
import storage from 'redux-persist/es/storage';
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  persistReducer,
  persistStore,
} from 'redux-persist';

const persistConfig = {
  key: 'root',
  storage,
};

const persistedUserProfileReducer = persistReducer(
  persistConfig,
  userProfileReducer.reducer,
);

export const store = configureStore({
  devTools: import.meta.env.MODE !== 'production',
  reducer: {
    userProfile: persistedUserProfileReducer,
    [backendApi.reducerPath]: backendApi.reducer,
  },
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
    backendApi.middleware,
  ],
});

export const persistor = persistStore(store);
